import Echo from "laravel-echo"
import Pusher from "pusher-js"
import axios from "axios"

declare global {
  interface Window {
    Pusher: typeof Pusher
  }
}

window.Pusher = Pusher

const echo = new Echo({
  broadcaster: "reverb",
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: Number(import.meta.env.VITE_REVERB_PORT),
  wssPort: Number(import.meta.env.VITE_REVERB_PORT),
  forceTLS: import.meta.env.PROD,
  enabledTransports: import.meta.env.PROD ? ["wss"] : ["ws", "wss"],
  authorizer: (channel: { name: string }) => ({
    authorize: (
      socketId: string,
      callback: (error: Error | null, data: { auth: string } | null) => void,
    ) => {
      axios
        .post(
          `${import.meta.env.VITE_API_URL}/broadcasting/auth`,
          { socket_id: socketId, channel_name: channel.name },
          {
            withCredentials: true,
            withXSRFToken: true,
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            headers: { Accept: "application/json" },
          },
        )
        .then((response) => callback(null, response.data))
        .catch((error) => callback(error instanceof Error ? error : new Error(String(error)), null))
    },
  }),
})

export { echo }
